import React, { useState, useEffect } from "react";
import MagazinePosts from "./MagazinePosts";

export default function MagazineAccordion() {
  const [categories, setCategories] = useState([]);
  const [expandedId, setExpandedId] = useState(null);
  const [magazinesByCategory, setMagazinesByCategory] = useState({});
  const [loading, setLoading] = useState(false);

  // Fetch magazine categories
  useEffect(() => {
    fetch('/api/Magazine/categories')
      .then(res => res.json())
      .then(setCategories);
  }, []);

  const handleExpand = async (cat) => {
    setExpandedId(prev => (prev === cat ? null : cat));
    if (!magazinesByCategory[cat]) {
      setLoading(true);
      // You can choose to use either of the APIs below:
      // fetch(`/api/Magazine/type/${cat}`)
      fetch(`/api/Magazine/recent/${cat}?pageNumber=1&pageSize=10`)
        .then(res => res.json())
        .then(data => {
          setMagazinesByCategory(prev => ({ ...prev, [cat]: data }));
          setLoading(false);
        });
    }
  };

  return (
    <div style={{ maxWidth: 700, margin: "40px auto" }}>
      <h2 style={{ fontSize: 24, fontWeight: 700, marginBottom: 24 }}>Magazines</h2>
      {categories.map((cat, idx) => (
        <div key={cat} style={{ marginBottom: 24 }}>
          <div
            onClick={() => handleExpand(cat)}
            style={{
              background: "#f4f7fd",
              borderRadius: 14,
              display: "flex",
              alignItems: "center",
              padding: "28px 32px",
              boxShadow: "0 2px 8px 0 rgba(0,0,0,0.03)",
              minHeight: 80,
              cursor: "pointer"
            }}
          >
            {/* Replace icon/color logic as needed */}
            <div style={{ fontSize: 40, marginRight: 22 }}>📚</div>
            <div>
              <div style={{
                fontSize: 20,
                fontWeight: 700,
                color: "#2563eb"
              }}>{cat}</div>
              <div style={{
                color: "#6b7280",
                fontSize: 14,
                marginTop: 6
              }}>
                {magazinesByCategory[cat]?.length || 0} posts
              </div>
            </div>
          </div>
          {expandedId === cat && (
            <div style={{
              background: "#fff",
              border: `2px solid #bae6fd`,
              borderRadius: 12,
              margin: "8px 0 8px 24px",
              padding: "1.5rem 2rem",
              boxShadow: "0 2px 8px 0 rgba(0,0,0,0.04)",
              fontSize: 17,
              color: "#444"
            }}>
              {loading && !magazinesByCategory[cat] ? (
                <div>Loading...</div>
              ) : (
                <MagazinePosts posts={magazinesByCategory[cat] || []} />
              )}
            </div>
          )}
        </div>
      ))}
    </div>
  );
}
